/**
 * Where the mobs of a spawn point stand: distinct walkable tiles around the
 * centre, nearest first, in a fixed order.
 *
 * Deterministic on purpose. Randomness would make the world differ between
 * two server boots and make the e2e tests flaky; a spiral gives a natural
 * cluster and the same one every time.
 */
export function spawnTiles(spawn, grid) {
    const candidates = [];
    for (let dy = -spawn.radius; dy <= spawn.radius; dy += 1) {
        for (let dx = -spawn.radius; dx <= spawn.radius; dx += 1) {
            const tile = { x: spawn.x + dx, y: spawn.y + dy };
            if (grid.isWalkableTile(tile))
                candidates.push(tile);
        }
    }
    // Nearest to the centre first; ties in reading order, which the loops
    // above already produce, and a stable sort keeps.
    candidates.sort((a, b) => Math.abs(a.x - spawn.x) +
        Math.abs(a.y - spawn.y) -
        (Math.abs(b.x - spawn.x) + Math.abs(b.y - spawn.y)));
    return candidates.slice(0, spawn.count);
}
//# sourceMappingURL=spawn-tiles.js.map